module.exports = __webpack_public_path__ + "static/linkedin-96db9a988b8334f13b71c721a6eded0a.png";